import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import CloseIcon from '@mui/icons-material/Close'
import { IconButton, Typography } from '@mui/material'
import withStyles from '@mui/styles/withStyles'

import { Space } from 'components/common/Styles'
import BlackTooltip from 'components/common/tooltips'
import AcquiringAdditionalCardsComponent from 'components/core/Acquiring/AcquiringAdditionalCards/AcquiringAdditionalCards'
import { ErrorAlert } from 'components/core/Alert'
import { Spinner } from 'components/core/Progress/Progress-component'
import ThreeColumnTable, { ThreeColumnTableHeader, ThreeColumnTableRow } from 'components/core/Tables/ThreeColumnTable/ThreeColumnTable'
import { startSettlementPdfDownload } from 'redux/acquiring/acquiring-actions'
import { useAppSelector } from 'redux/hooks'
import { IMAGES_PATH, themeStyles } from 'themes'
import { dateToLocaleString } from 'utils/helperNumbersFormating'

const pdfOval = IMAGES_PATH('/downloadOval.svg')

interface AcquiringSettlementProps {
    record: ParsedRecord
    handleClose: () => void
    classes: Record<string, string>
}

const AcquiringSettlement: FC<AcquiringSettlementProps> = ({ record, classes, handleClose }) => {
    const dispatch = useDispatch()
    const { loader } = useAppSelector(state => state.acquiring)
    const { t } = useTranslation()

    const handleDownload = () => {
        dispatch(startSettlementPdfDownload({ id: record.id }))
    }

    return (
        <>
            <div className={classes.modalFixedHeader}>
                <Typography data-sta-id="acquiring-h1-title" variant="h1">
                    {t('Acquiring.Settlement')} {dateToLocaleString(record.settledAt)}
                </Typography>
                <IconButton
                    data-sta-id="acquiring-button-close"
                    aria-label="close"
                    className={classes.modalCloseButton}
                    onClick={handleClose}
                    size="large"
                >
                    <CloseIcon />
                </IconButton>
            </div>
            <div className={classes.modalContent}>
                <ErrorAlert />
                {record?.settlementsDataByCurrency?.map(({ currencyCode, data, additionalData }, i) => (
                    <div key={`settlementsDataByCurrency-${i}`}>
                        <Space top={i >= 1 && '30'} />
                        <AcquiringAdditionalCardsComponent
                            currencyCode={currencyCode}
                            leftHeader={additionalData.finalAmount.name}
                            leftValue={additionalData.finalAmount.value}
                            rightHeader={additionalData.rollingReserveReleasedVolume.name}
                            rightValue={additionalData.rollingReserveReleasedVolume.value}
                        />
                        <ThreeColumnTable>
                            <ThreeColumnTableHeader tableHeaders={[currencyCode, t('Acquiring.QTY'), t('Acquiring.Volume')]} />
                            {data.map((tableValues, j) => (
                                <ThreeColumnTableRow key={`threeColumnTableRow-${j}`} tableValues={tableValues} />
                            ))}
                        </ThreeColumnTable>
                    </div>
                ))}
                <div>
                    <br />
                    {loader?.SETTLEMENT_PDF_DOWNLOAD ? (
                        <Spinner />
                    ) : (
                        <BlackTooltip data-clipboardtarget title={`${t('Acquiring.Download')} PDF`} placement="top" arrow={true}>
                            <img
                                src={pdfOval}
                                alt={`${t('Acquiring.Download')} PDF`}
                                onClick={handleDownload}
                                style={{ cursor: 'pointer' }}
                            />
                        </BlackTooltip>
                    )}
                </div>
            </div>
        </>
    )
}

export default withStyles(themeStyles.useModalStyles)(AcquiringSettlement)
